import pic1 from '../../../images/pic1.png';
import pic2 from '../../../images/pic2.png';
import pic3 from '../../../images/pic3.png';

function ThirdContent() {

    return (
        <div className="flex flex-col items-center justify-center w-full overflow-x-hidden">
            <div className="flex flex-col items-center text-primary pt-40 max-w-7xl w-full overflow-hidden pb-40 px-10" id="more">
                <div className="flex flex-col items-center w-5/6 text-center">
                    <span className="w-full font-bold text-5xl m6:text-4xl translate-y-16 opacity-0" id='third-comp-quote'>
                        « La référence en termes d'application de maintenance. Fiable, innovante {'&'} efficace. »
                    </span>
                    <span className="w-full text-3xl m6:text-2xl mt-10" id='third-comp-quote-author'>
                        P. Matthis, responsable neige de Val d'Isère Téléphérique.
                    </span>

                </div>
                <div className="w-full flex flex-row m10:flex-col m10:items-center m10:gap-20 justify-between mt-52">
                    <div className="w-1/4 m6:w-full i3:w-1/2 i4:w-1/2 m10:-mx-4 flex flex-row" id='third-comp-ind-1'>
                        <img src={pic1} alt='pic1' className="h-28" />
                        <div className="flex flex-col pl-4">
                            <span className="font-bold text-4xl">
                                <span>+</span><span className="text-5xl" id='percent-to-up-1'>0</span><span>%</span>
                            </span>
                            <span className="uppercase text-lg">
                                en gain de productivité {"("}h/technicien{")"}
                            </span>
                        </div>
                    </div>
                    <div className="w-1/4 m6:w-full i3:w-1/2 i4:w-1/2 m10:-mx-4  flex flex-row" id='third-comp-ind-2'>
                        <img src={pic2} alt='pic2' className="h-28" />
                        <span className="uppercase text-lg pt-6 pl-4">
                            Personnalisable à souhait pour l'entreprise
                        </span>
                    </div>
                    <div className="w-1/4 m6:w-full i3:w-1/2 i4:w-1/2 m10:-mx-4 flex flex-row" id='third-comp-ind-3'>
                        <img src={pic3} alt='pic3' className="h-28" />
                        <div className="flex flex-col pl-4">
                            <span className="font-bold text-4xl">
                                <span>+</span><span className="text-5xl" id='percent-to-up-3'>21</span><span>%</span>
                            </span>
                            <span className="uppercase text-lg">
                                en réduction budget
                            </span>
                        </div>
                    </div>
                </div>
                <span className="font-bold text-4xl w-full mt-80 text-center" id='third-comp-transi-sent'>
                    Travaillez avec les meilleurs outils de gestion
                </span>
            </div>
        </div>
    );

}

export default ThirdContent;